import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["toggle", "content", "rows", "template", "row", "add"];
  static values = { firstMonthCount: { type: Number, default: 3 } };

  connect() {
    this.nextIndex = Date.now();
    this.refresh();
  }

  toggle() {
    if (this.toggleTarget.checked && this.activeRows.length === 0) {
      this.add();
    } else {
      this.refresh();
    }
  }

  add() {
    if (!this.toggleTarget.checked || this.activeRows.length >= 9) return;
    const first = this.activeRows.length === 0;
    const index = String(this.nextIndex++);
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("NEW_PHASE", index));
    const row = this.activeRows.at(-1);
    if (first) {
      const form = this.element.closest("form");
      const price = form.querySelector('[name="subscription_type[price]"]');
      const period = form.querySelector('[name="subscription_type[period]"]');
      if (price) row.querySelector('input[name$="[price]"]').value = price.value;
      if (period?.value) row.querySelector('select').value = period.value;
      const rhythm = row.querySelector('select').value;
      row.querySelector('input[name$="[periods_count]"]').value = rhythm === "month" ? String(this.firstMonthCountValue) : "1";
    }
    this.refresh();
    row.querySelector('input[type="number"]')?.focus();
  }

  remove(event) {
    const row = this.rowTargets.find(row => row.contains(event.currentTarget));
    row.hidden = true;
    if (this.activeRows.length === 0) this.toggleTarget.checked = false;
    this.refresh();
    (this.toggleTarget.checked ? this.addTarget : this.toggleTarget).focus();
  }

  get activeRows() {
    return this.rowTargets.filter(row => !row.hidden);
  }

  refresh() {
    const enabled = this.toggleTarget.checked;
    const rows = this.activeRows;
    this.contentTarget.hidden = !enabled;
    this.rowTargets.forEach(row => {
      const disabled = !enabled || row.hidden;
      // Keep IDs/destruction flags submittable; drafts stay in the DOM until save.
      row.querySelector('input[name$="[_destroy]"]').value = disabled ? "1" : "0";
      row.querySelectorAll("input:not([type=hidden]), select").forEach(input => input.disabled = disabled);
    });
    rows.forEach((row, index) => {
      row.querySelector('input[name$="[position]"]').value = index + 1;
      row.querySelector('[data-phase-number]').textContent = index + 1;
      row.querySelector('input[name$="[periods_count]"]').required = index === 0 || index < rows.length - 1;
    });
    this.addTarget.disabled = rows.length >= 9;
    this.dispatch("changed", { prefix: "price-phases" });
  }
}
